import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './ServiceRequestFormQuestion.scss';
import { selectItemFaqById } from '../../store/selectors/items';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import { setServiceRequestFormPreviousStep, setServiceRequestFormNextStep, exitServiceRequestForm } from '../../store/actions/serviceRequestForm';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Row from '../Row';
import { variables } from '../../Tenants';

class ServiceRequestFormQuestion extends Component {
  render() {
    const { serviceRequestFormData, onSetServiceRequestFormNextStep, onSetServiceRequestFormPreviousStep, onExitServiceRequestForm, itemFaq, onExit } = this.props;
    return (
      <Form
        headline={itemFaq.caption}
        onClose={onSetServiceRequestFormPreviousStep}
        onExit={() => {
          onExitServiceRequestForm();
          if (onExit) onExit();
        }}
        component={(
          <Row mdCenter>
            <Col
              xs="12"
              md="6"
            >
              <div className="service-request-form-question__photo">
                <a href={itemFaq.image} target='_blank'>
                  <img src={itemFaq.image} />
                </a>
              </div>
              <div className="service-request-form-question__body">
                {itemFaq.linkTitle}
              </div>
            </Col>
          </Row>
        )}
        footer={(
          <div style={{position: "fixed",
          bottom: "0",left:'0',
          width: "100%",
          background: "#fff", padding:'15px',boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)'}}>
          <>
            Did this help you resolve the issue?
            <br />
            <br />
            <Button
              color="teal"
              size="small"
              label='Yes, Return to Dashboard'
              onClick={() => onExitServiceRequestForm()}
            />
            <Button
              color="teal"
              size="small"
              label={`No, Submit ${variables.serviceRequest}`}
              onClick={() => onSetServiceRequestFormNextStep()}
            />
          </>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = state => {
  const serviceRequestFormData = selectServiceRequestFormData(state);
  return {
    itemFaq: selectItemFaqById(state, serviceRequestFormData.asset_item_id, serviceRequestFormData.faq_id),
    serviceRequestFormData,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onSetServiceRequestFormNextStep: setServiceRequestFormNextStep,
  onSetServiceRequestFormPreviousStep: setServiceRequestFormPreviousStep,
  onExitServiceRequestForm: exitServiceRequestForm,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestFormQuestion);
